import { useQuery } from "@tanstack/react-query";
import { getDetectPastDetail } from "../api/detect";
import { DeleteMobility } from "../types/types";

const useGetDetectPastDetail = (
    { seq }: DeleteMobility,
    { fetch } : { fetch: boolean; }
) => {
    const { data, isLoading, isSuccess } = useQuery({
        queryKey: ["DetectPastDetail", `seq-${seq}`, `fetch-${fetch}`],
        queryFn: () => getDetectPastDetail({ seq }),

        retry: false,
        enabled: fetch,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    return {data, isLoading, isSuccess};
};

export default useGetDetectPastDetail;